var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"none"}},[_c('v-main',[_c('Background',{attrs:{"app":""}}),_c('HelloWorld'),_c('SocialButton')],1),_c('NavigationToolbar',{attrs:{"app":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }